export default function VisaCardIcon({
    style
}) {
    return <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 24">
        <g fill="#1a1f71">
            <path d="M3.214 1h29.572c1.3 0 2.214 1 2.214 2.142v17.716c0 1.142-.914 2.142-2.214 2.142H3.214C1.914 23 1 22 1 20.858V3.142C1 1.999 1.914 1 3.214 1zm.286 2v17h29.286V3H3.5zM2 6.429h32V19H2V6.429zm14.571 6.857v2.571h1.714v-2.571h2.571v-1.714h-2.571v-2.571h-1.714v2.571H13.857v1.714h2.714zm1.143-2.571v-2.571h-1.714v2.571H16.57z" />
        </g>
    </svg>
}